export default {
  username: 'Username',
  password: 'Password',
  checkPass: 'Confirm Password',
  confirm_password: 'Confirm Password',
  add_user: 'Add New User',
  modify_pwd: 'Change Password',
  modify_withdraw_type: 'Modify Withdraw Type',
  reset_password: 'Reset Password',
  pay_password_setting: 'Pay Password Setting',
  second_after_regain: 'Second After Regain',
  verify: 'Verify',
  send_verification_code: 'Send Verification Code',
  verification_code: 'Verification Code:',
  login_email: 'Login Email',
  authorized: 'Authorized',
  authorized_status: 'Activation Status',
  authority: 'Permissions',
  role: 'Role',
  modify_auth: 'Modify Authority',
  assign_role: 'Assign Role',
  modify_role: 'Edit Role',
  mch_order_id: 'Mch Order Id',
  payout_mch_order_id: 'Mch Order Id',
  amount: 'Amount',
  channel_code: 'Channel Code',
  payout_status: 'Payout Status',
  refund_method: 'Refund method',
  contact_details: 'Contact Details',
  customerService_email: 'Customer Service Email',
  customerService_phone_number: 'Customer Service Phone Number',
  payment_amount_cents_tips: 'payment amount (unit: cents) {currency}:500.10, should set 50010 cents',
  payment_amount_peso_tips: 'payment amount (unit: peso) {currency}:500.10, should set 500.10 peso',
  payment_amount_tips: 'payment amount (unit: cents) {currency}:500.10, should set 50010 cents',
  payment_amount_tips_id: 'payment amount (unit: yuan) {currency}:50010, should set 50010',
  reset_mfa: 'Reset MFA',
  mfa_verify_code: 'MFA Verification Code',
  mfa_code_required: 'MFA verification code cannot be empty',
  mfa_status: 'MFA Status',
  remark: 'Remark',
  role_name: 'Role Name',
  add_role: 'Add New Role',
  user_authentication: 'User Authentication',
  role_details: 'Role Details',
  permissions: 'Permissions',
  account_details: 'Account Details',
  password_details: 'Password Details',
  change_your_password: 'Change your Password',
  change_bank_info: 'Change Bank Info',
  change_withdraw_info: 'Change Withdraw Info',
  edit_bank: 'Edit Bank',
  bank_details: 'Bank Details',
  withdraw_details: 'Withdraw Details',
  copy_bank_passbook_wallet: 'Copy of Bank Passbook/E-wallet',
  business_permit: 'Business Permit',
  bir_registraon: 'BIR Registration',
  certificate_authorized_representative: 'Certificate of the Authorized Representative',
  article_of_incorporation: 'Annual Report(GIS)',
  withdraw_type: 'Cash Out Type',
  auto_withdraw_type: 'Auto Cash Out Type',
  pos_withdraw_config_locked: 'This merchant is a POS special-withdrawal merchant. The cash out type, auto cash out method and cycle are locked by the system. Please contact customer service to change them.',
  reviewing: 'Reviewing',
  activated: 'Activated',
  reject: 'Reject',
  dismiss: 'Dismiss',
  dismiss_reason: 'Dismiss Reason',
  the_next_day: 'The Next Day',
  handling_fee: 'Handling fee',
  per_transaction: 'per transaction',
  update_role: 'Update Role',
  kyc_unverified: 'Unverified',
  kyc_pending: 'Pending',
  kyc_verified: 'Verified',
  kyc_rejected: 'Rejected',
  notification_config: 'Notification Configuration',
  config: 'Configuration',
  trade_daily_report_notification: 'Trade Daily Report Notification',
  send_trade_daily_notification: 'Send Trade Daily Report Notification At Fixed Time',
  scheduled_send: 'Scheduled Send',
  send_time: 'Send Time',
  send_test_email: 'Send Test Email',
  balance_alert_notification: 'Balance Alert Notification',
  balance_alert_description: 'Send Notification When Balance Is Less Than Set Amount',
  event_trigger: 'Event Trigger',
  alert_amount: 'Alert Amount',
  add_alert_amount: 'Add Alert Amount',
  email_notification: 'Email Notification',
  notification_types: 'Notification Types',
  notification_config_tip: 'Please select the notification types this user needs to receive',
  receive_notification: 'In-app Notifications:',
  send_test_notification: 'Send Test Notification',
  warn_amount: 'Alert Amount',
  warn_amount_placeholder: 'Please enter alert amount',
  warn_amount_invalid: 'Please enter a valid alert amount',
  warn_amount_exists: 'This alert amount already exists',
  warn_amount_duplicate: 'Duplicate alert amounts are not allowed',
  warn_amount_min_error: 'Amount must be greater than 0.',
  warn_amount_max_error: 'Amount cannot exceed 999,999,999,999.',
  add: 'Add',
  add_warn_amount: 'Add Alert Amount',
  save: 'Save',
  cancel: 'Cancel'
}
